<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-4">
                <strong>Zeitpunkt</strong>
                <br>
                <span v-html="entryTimeString"></span>
            </div>
            <div class="col-12 col-md-8" v-if="entry.calendar_title">
                <person-box :image="calendar.preview && calendar.preview.paths && calendar.preview.paths.preview || ''"
                    :default-icon="options.calendarIcon" :color="options.moduleColor" :abbreviation-avatar="false">
                    <template #name>
                        {{entry.calendar_title}}
                    </template>
                </person-box>
            </div>
        </div>

        <div class="row" v-if="entry.institution_id">
            <div class="col-12 col-md-4">
                <span>Mandat:</span>
                <router-link v-if="!entry.institution_deleted" :to="'/contact/entry/view/id/' + entry.institution_id">
                    {{entry.institution_name}} ({{entry.institution_id}})
                </router-link>
                <span v-else>
                    {{entry.institution_name}}
                </span>
            </div>
        </div>

        <div v-if="entry.description" class="default-margin-top message-content fr-view">
            <div><strong>Beschreibung</strong></div>
            <div v-html="entry.description"></div>
        </div>

        <div v-if="entry.description_additional" class="default-margin-top message-content fr-view">
            <div><strong>Zusätzliche Informationen:</strong></div>
            <div v-html="entry.description_additional"></div>
        </div>

        <div v-if="entry.reservation && entry.reservation.prename" class="default-margin-top">
            <div><strong>Webseitenbuchung - Angegebene Kontaktdaten:</strong></div>
            <p>
                Name: {{entry.reservation.prename}} {{entry.reservation.name}}
                <br>
                E-Mail: {{entry.reservation.email}}
                <template v-if="entry.reservation.phone">
                    <br>
                    Telefon: {{entry.reservation.phone}}
                </template>
            </p>
            <template v-if="entry.reservation.message">
                <div><strong>Webseitenbuchung - Angegebene Nachricht:</strong></div>
                <p v-html="entry.reservation.message"></p>
            </template>
        </div>

        <div v-if="'vehicle' === resource && entry.destination || entry.street || entry.street_number || entry.street_addition || entry.postcode || entry.city">
            <div><strong>Zielinformationen</strong></div>
            <div class="spacer-10">
                <template v-if="entry.destination">
                    {{entry.destination}}
                    <br>
                </template>
                <template v-if="entry.street || entry.street_number">
                    {{entry.street}} {{entry.street_number}}
                    <br>
                </template>
                <br>
                <template v-if="entry.street_addition">
                    {{entry.street_addition}}
                    <br>
                </template>
                {{entry.postcode}} {{entry.city}}
            </div>
        </div>

        <div class="default-margin-top">
            <div><strong>{{entry.resource && noCategoryResources.includes(entry.resource) ? 'Modul' : 'Kategorie'}}</strong></div>
            <div class="colour-badge">
                <div class="colour-badge-preview" :style="{backgroundColor: '#' + entry.category_color}"></div>
                <div class="colour-badge-text">
                    {{entry.category_name}}
                </div>
            </div>
        </div>

        <template v-if="entry.clients && entry.clients.length">
            <hr>

            <div>
                <div><strong>Ansprechpartner - Reservierung</strong></div>
                <div class="user-container-list">
                    <person-box-user v-for="contact in entry.clients" :key="'calendar-client-' + contact" :id="contact"/>
                </div>
            </div>
        </template>

        <hr v-if="showAddress || isCalendarEntry">

        <div class="row">
            <div v-if="showAddress" class="col-12 col-md-3">
                <div><strong>Adresse</strong></div>
                <div class="spacer-10">
                    {{calendar.street}} {{calendar.street_number}}
                    <br>
                    <template v-if="calendar.street_addition">{{calendar.street_addition}}
                        <br>
                    </template>
                    {{calendar.postcode}} {{calendar.city}}
                </div>
            </div>
            <div v-if="calendar.contacts && calendar.contacts.length" class="col-12 " :class="{'col-md-9': showAddress}">
                <div><strong>Ansprechpartner - {{options.calendarType}}</strong></div>
                <div class="user-container-list">
                    <person-box-user v-for="contact in calendar.contacts" :key="'calendar-contact-' + contact" :id="contact"></person-box-user>
                </div>
            </div>
        </div>

        <div v-if="isCalendarEntry" class="spacer-15">
            <router-link :to="{name: resource + '-list', params: {id: calendar.id}}">
                <span>{{options.calendarType}} ansehen</span> <i class="material-icons md-16" aria-hidden="true" role="img">open_in_new</i>
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator';
    import PersonBox from '../../../components/PersonBox.vue';
    import PersonBoxUser from '../../../components/PersonBoxUser.vue';
    import ACalendarComponent from '../../../library/modules/calendar/ACalendarComponent';
    import {getEntryTimeString, noCategoryResources} from '../../../library/modules/calendar/calendar';
    import {calendarResourceOptions} from '../../../library/modules/calendar/options';

    @Component({
        name: 'CalendarEntryViewContent',
        components: {
            PersonBoxUser,
            PersonBox,
        },
    })
    export class CalendarEntryViewContent extends ACalendarComponent
    {
        @Prop({
            type: Object,
            required: true,
        }) entry: CalendarEntryData;

        @Prop({
            type: Object,
            required: true,
        }) calendar: CurrentCalendarData | CalendarData;

        get entryTimeString()
        {
            return getEntryTimeString(this.entry, false);
        }

        get showAddress()
        {
            return !!(this.calendar.street || this.calendar.street_number || this.calendar.street_addition || this.calendar.postcode || this.calendar.city);
        }

        get isCalendarEntry()
        {
            return this.entry.resource && Object.keys(calendarResourceOptions).includes(this.entry.resource);
        }

        noCategoryResources = noCategoryResources;
    }

    export default CalendarEntryViewContent;
</script>